<template>
  <div>
    <ez-user-list
      :users="users"
      :columns="['name', 'email', 'role', 'accountName']"
      :headers="{
        accountName: () => `${$helpers.remapNaming('venue')}`,
      }"
      :columnProps="{
        venue: { class: 'venue-cell' },
        role: { class: 'role-cell' },
      }"
      @addUser="onAddUser"
      @userClick="onUserClick"
      @removeUser="onRemoveUser">
      <ez-venue-user-modal
        ref="userModal"
        :roles="roles"
        :formKey="formKey"
        :formAction="formAction"
        :groupId="groupId"
        :userId="selectedUserId"></ez-venue-user-modal>
    </ez-user-list>
    <ez-loader :show="isLoading">Loading...</ez-loader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EzUserList, { EzVenueUserModal } from '@/views/common/users';
import User from '@/models/User';
import EzLoader from '@/components/ui/Loader/EzLoader';
import { LOADING_KEY } from '@/util/constants';

export default {
  components: {
    EzLoader,
    EzUserList,
    EzVenueUserModal,
  },
  props: {
    groupId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      formKey: 'venue-group-user',
      selectedUserId: null,
      roles: [],
    };
  },
  computed: {
    formAction() {
      return `admin/venue-groups/${this.groupId}/users`;
    },
    users() {
      return User.query()
        .with('venue')
        .where('groupId', this.groupId)
        .all();
    },
    ...mapGetters('loading', ['getLoading']),
    isLoading() {
      return this.getLoading(LOADING_KEY.GET_USERS);
    },
  },
  methods: {
    openModal() {
      this.$refs.userModal.open();
    },
    closeModal() {
      this.$refs.userModal.close();
    },
    onAddUser() {
      this.selectedUserId = -1;
      this.openModal();
    },
    onUserClick({ id }) {
      this.fetchAdminVenueUser({ groupId: this.groupId, id })
        .then(() => {
          this.selectedUserId = id;
          this.openModal();
        });
    },
    onRemoveUser({ id }) {
      this.removeAdminVenueUser({ groupId: this.groupId, id })
        .then(() => this.fetchAdminVenueUsers({ groupId: this.groupId }));
    },
    ...mapActions('entities/users', [
      'fetchAdminVenueUsers',
      'fetchAdminVenueUser',
      'removeAdminVenueUser',
    ]),
    ...mapActions('roles', [
      'getAdminVenueRoles',
    ]),
  },
  async mounted() {
    this.fetchAdminVenueUsers({ groupId: this.groupId });

    this.roles = await this.getAdminVenueRoles();
  },
};
</script>
